import React, { Component } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../../constants/styles';

import OPComponent from '../../op_component';
import CTAButton from '../../cta_button';
import ImagePicker from './image_picker';
import { LinkRemove } from './image_remove';
import FormInput from '../text_input';

export default class FilesInput extends OPComponent {
  constructor(props) {
    super(props);
  }

  openImagePicker = () => {
    ImagePicker.selectImage('application/pdf').then(({ image }) => {
      this.props.onAdd?.({ image });
    });
  };

  renderExistingAttachment = (attachment, i) => {
    return (
      <LinkRemove
        containerStyle={{}}
        key={i}
        attachment={attachment}
        onRemove={this.props.onDelete}
        hideRemoveButton={true}
        onPress={this.props.onLinkPress}
      />
    );
  };

  render() {
    const { attachments, newAttachments, onAdd, disabled } = this.props;
    const newAttachment = newAttachments?.[0];

    return (
      <View style={THEME.container}>
        {!!(attachments?.length || newAttachments?.length) && (
          <View style={styles.images}>{attachments?.map?.(this.renderExistingAttachment)}</View>
        )}

        <ImagePicker onSelect={onAdd} fileType={'application/pdf'} />

        <View style={{ flexDirection: 'row', alignItems: 'stretch' }}>
          <CTAButton
            onPress={this.openImagePicker}
            label="Choose File"
            style={{ width: 180, marginTop: 4 }}
          />
          <View style={{ flex: 1, justifyContent: 'flex-end', paddingLeft: 20 }}>
            <FormInput
              value={newAttachment?.image?.fileName || ''}
              required={false}
              editable={false}
              label="Submit Document"
              controlled={true}
            />
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  images: {
    paddingVertical: 10,
  },
  imageContainer: {
    marginRight: 5,
  },
});
